// /**
//  *  @class
//  *  @function NewsLetterPopup
//  */
// class NewsLetterPopup {
//   constructor(targetElement) {
//     this.popupType_flg = false;

//     this.popupContainer = document.getElementById("NewsLetterCustomer--Modal");
//     this.popupInnerElements = document.querySelectorAll(".js-newsLetter-PopupInner");

//     this.popupShowTargetElement = document.getElementById(targetElement);

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     const closeBtns = this.popupContainer.querySelectorAll(".p-popup__js-closeElement");
//     closeBtns.forEach((closeBtn) => {
//       closeBtn.addEventListener("click", (event) => {
//         this.closePopup();
//       });
//     });

//     let langSelectors = this.popupContainer.querySelectorAll(".customerLangSelector_popup");
//     langSelectors.forEach((langSelector) => {
//       langSelector.addEventListener("change", (event) => {
//         this.changeTags(event);
//       });
//     });

//     const signupBtns = document.querySelectorAll('.signup_button');

//     signupBtns.forEach((btn) => {
//       btn.addEventListener('click', (event) => {
//         event.preventDefault(); // リンクの場合
//         this.showPopup();
//       });
//     });
//   }

//   /*  */
//   closePopup() {
//     this.popupContainer.classList.remove("active");
//   }

//   changeTags(event) {
//     /*     let langSelector = this.popupInnerElement.querySelectorAll(".customerLangSelector_popup");
//      */
//     let changeValue = event.target.value;
//     let targetInput;
//     if (this.popupType_flg == true) {
//       targetInput = document.getElementById("customerTags_popup_ORIHICA");
//     } else {
//       targetInput = document.getElementById("customerTags_popup_COMMON");
//     }
//     targetInput.value = changeValue;
//   }

//   showPopup(targetElement) {
//         this.popupContainer.classList.add("active");
//         this.popupShowTargetElement.classList.add("active");
//   }
// }


/**
 *  @class
 *  @function NewsLetterPopup
 */

class NewsLetterPopup {
  constructor(targetElementId) {
    this.popupType_flg = false;
    this.param = this.getUrlParam("taxfreestore");

    if (this.param === "subscription") {
      this.popupType_flg = true;
    }

    // ★追加: initAutoPopupでCookieが付与される前に、今回のアクセスが初回かどうかを判定して保持する
    let hasCookie = document.cookie.split(";").some((item) => item.trim().startsWith("NewsLetter_popup="));
    // Cookieがない、またはURLパラメータによって強制初回扱いになる場合は true
    this.isFirstVisit = !hasCookie || this.popupType_flg;

    // HTML側で設定した data-newsletter 属性を持つコンテナを全て取得
    this.popupContainers = document.querySelectorAll("[data-newsletter]");

    this.setupEventListeners();

    // コンテナごとに data-newsletter の値を見て処理を振り分け
    this.popupContainers.forEach(container => {
      const type = container.dataset.newsletter;

      if (type === "normal") {
        // 値が "normal" の場合は自動表示（クッキー・タイマー処理あり）
        this.initAutoPopup(container);
      } else {
        // 値がない場合（またはnormal以外）は手動表示（ボタンクリック）
        // register-btn の取得を確実にするため、loadイベント後に実行する
        window.addEventListener('load', () => {
          this.initManualPopup(container);
        });
      }
    });
  }

  // 共通のイベントリスナー（閉じるボタン・言語切り替え）
  setupEventListeners() {
    this.popupContainers.forEach(container => {
      // 閉じるボタン
      container.querySelectorAll(".p-popup__js-closeElement").forEach((closeBtn) => {
        closeBtn.addEventListener("click", (event) => {
          this.closePopup(container);
        });
      });

      // 言語切り替え
      container.querySelectorAll(".customerLangSelector_popup").forEach((langSelector) => {
        langSelector.addEventListener("change", (event) => {
          this.changeTags(event, container);
        });
      });

      document.querySelectorAll('.signup_button').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault(); // リンクの場合
          this.showPopup();
        });
      });
    });

    // 共通の背景(オーバーレイ)に対する閉じるイベント
    const bg = document.querySelector(".p-popup__js-closeElement.p-popup__bg");
    if (bg) {
      bg.addEventListener("click", () => {
        // 背景クリック時は、全てのコンテナを閉じる
        this.popupContainers.forEach(container => {
          if (container.dataset.newsletter !== "normal") {
            this.closePopup(container);
          }
        });
      });
    }
  }

  // ページ流入時の自動表示ロジック
  initAutoPopup(container) {
    let targetInnerId = this.param === "subscription" ? "newsLetter-Popup--ORIHICA_TaxFree" : "newsLetter-Popup--COMMON";
    let targetInner = container.querySelector(`#${targetInnerId}`);

    if (this.param === "subscription") {
      this.popupType_flg = true;
      this.showPopup(container, targetInner, 2000); // 2秒後に表示
    } else {
      let cookieFlg = this.cookieCheck();
      if (!cookieFlg) {
        this.showPopup(container, targetInner, 2000); // クッキーがなければ2秒後に表示
      }
    }
  }

  // register-btn クリック時の手動表示ロジック
  initManualPopup(container) {
    const triggerBtns = document.querySelectorAll('#register-btn, .newsletter-btn');
    if (triggerBtns.length === 0) return;

    triggerBtns.forEach((btn) => {
      // 初回流入時（自動ポップアップが表示される状態）のクラス付与
      if (this.isFirstVisit) {
        btn.classList.add('first_view');
      }

      // 重複登録を防ぐため、一度古いイベントリスナーがあれば削除する（簡易的な方法としてクローンして入れ替える）
      const newBtn = btn.cloneNode(true);
      if (btn.parentNode) {
        btn.parentNode.replaceChild(newBtn, btn);
      }

      // 2回目以降（ボタンを表示する状態）に任意のclassを付与する
      // .newsletter-btn には付与しないように条件分岐
      if (!newBtn.classList.contains('newsletter-btn')) {
        newBtn.classList.add('is-show');
      }

      newBtn.addEventListener('click', (e) => {
        e.preventDefault();

        // 手動用はIDに _Manual が付与されている前提
        let targetInnerId = "newsLetter-Popup--COMMON_Manual";
        let targetInner = container.querySelector(`#${targetInnerId}`);

        // クリック時は遅延なし（0ミリ秒）で即時表示
        this.showPopup(container, targetInner, 0);
      });
    });
  }

  getUrlParam(paramKey) {
    let url = new URL(window.location.href);
    return url.searchParams.get(paramKey);
  }

  cookieCheck() {
    let hasCookie = false;
    if (document.cookie.split(";").some((item) => item.trim().startsWith("NewsLetter_popup="))) {
      hasCookie = true;
    }

    if (this.popupType_flg == true) {
      return false;
    } else if (!hasCookie) {
      document.cookie = "NewsLetter_popup=showPopup; max-age=604800";
      return false;
    } else {
      return true;
    }
  }

  closePopup(container) {
    // コンテナ自身の active を外す
    container.classList.remove("active");

    // コンテナ内のフォーム要素の active を外す
    container.querySelectorAll('.js-newsLetter-PopupInner').forEach(inner => {
      inner.classList.remove("active");
    });

    // 共通の背景オーバーレイの active を外す
    const bg = document.querySelector(".p-popup__js-closeElement.p-popup__bg");
    if (bg) bg.classList.remove("active");
  }

  changeTags(event, container) {
    let changeValue = event.target.value;
    let targetInput;

    // 操作されたコンテナが normal か手動用かによってSuffixを切り替え
    const suffix = container.dataset.newsletter === "normal" ? "" : "_Manual";

    if (this.popupType_flg == true) {
      targetInput = container.querySelector(`#customerTags_popup_ORIHICA${suffix}`);
    } else {
      targetInput = container.querySelector(`#customerTags_popup_COMMON${suffix}`);
    }

    if (targetInput) targetInput.value = changeValue;
  }

  showPopup(container, targetInner, delay = 2000) {
    setTimeout(() => {
      container.classList.add("active");

      if (targetInner) {
        targetInner.classList.add("active");
      }

      if (container.dataset.newsletter !== "normal") {
        const bg = document.querySelector(".p-popup__js-closeElement.p-popup__bg");
        if (bg) {
          bg.classList.add("active");
        }
      }
    }, delay);
  }
}
